import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

/**
 * Merchant HSA dashboard data from the DBT.ATTACHMENT.HSA_ATTACHMENT mart:
 * whole-order shop-currency values; HSA = any Gale payment on the order.
 */
export const getHsaDashboardMetrics = {
  name: "getHsaDashboardMetrics" as const,
  input: z.object({ startDate: isoDate, endDate: isoDate }),
  output: z.object({
    /** Daily HSA orders and whole-order value. */
    series: z.array(
      z.object({ date: isoDate, orders: z.number(), gross: z.number() }),
    ),
    totalOrders: z.number(),
    totalGross: z.number(),
    /** Orders containing at least one HSA/FSA-eligible item. */
    eligibleOrders: z.number(),
    /**
     * HSA-paid over HSA-eligible, both excluding exchange orders (not real
     * checkout opportunities); null when nothing was eligible.
     */
    adoptionRate: z.number().nullable(),
    /**
     * The adoption rate's numerator and denominator, for the adoption funnel;
     * both null when the warehouse read failed.
     */
    attachableEligibleOrders: z.number().nullable(),
    attachableOrders: z.number().nullable(),
    /** Orders with no Gale payment at all; disjoint from totalOrders. */
    nonHsaOrders: z.number(),
    nonHsaGross: z.number(),
    shopCurrency: createEnum(Currency),
  }),
};
